const t = "dsToast";
export {
  t as toastKey
};
//# sourceMappingURL=design-system.es7.js.map
